import { Pipe, PipeTransform } from '@angular/core';

/** Shared logic for display label (e.g. for sorting dropdowns by label). */
export function titlizeLabel(input: string): string {
  if (!input) return input;
  let s = input.split('/')
    .map(w1 => w1.replace(/_/g, ' ').replace(/-/g, ' ').split(' ').map(w => w.charAt(0).toUpperCase() + w.substring(1).toLowerCase()).join(' '))
    .join('/');
  s = s.replace('Hcp', 'HCP');
  // The 'awaiting_hcp' sub-status is displayed as "Awaiting RSVPs" (renamed from "Awaiting HCP").
  // The underlying id is unchanged, so this maps the id-derived label to the new display text.
  if (s === 'Awaiting HCP') return 'Awaiting RSVPs';
  if (s === 'Owner') return 'Host';
  return s;
}

@Pipe({ name: 'titlize' })
export class TitlizePipe implements PipeTransform {
  transform(input: string): string {
    return titlizeLabel(input);
  }
}
